var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessory5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 60,
    viewBox: "0 0 101 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_6887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51881 59.1866C2.21652 29.3359 30.7326 5.77096 59.7015 11.9607C79.7427 15.9305 95.8072 34.1326 96.2395 54.6679C96.2567 56.1775 96.2189 57.6838 96.1023 59.1866C95.8964 57.0422 95.543 54.6541 95.0901 52.5509C90.6708 31.7137 71.7413 15.6389 50.3105 15.7967C26.104 15.7589 6.36475 35.2786 4.51881 59.1866Z",
    fill: "#1E1E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8661 17.6771C30.8661 17.6771 29.9432 1.39984 7.06445 2.44633C7.06445 2.44633 -6.53651 25.9667 12.6915 32.201C18.4386 25.802 24.5323 21.1528 30.8661 17.6736V17.6771Z",
    fill: "#E2A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4365 34.9701L11.9508 34.4897C6.5056 32.7227 2.86518 29.5283 1.1256 24.9958C-2.76872 14.85 4.66652 1.79457 4.98561 1.24559L5.64439 0.10989L6.95508 0.0481298C14.0438 -0.274396 23.6955 0.871599 29.4323 8.18675C32.9492 12.6678 33.2512 17.3444 33.2615 17.54L33.3473 19.0531L32.0194 19.7805C25.4488 23.39 19.7086 27.9775 14.4761 33.8069L13.433 34.9701H13.4365ZM8.53682 4.80709C6.97223 7.93628 3.10879 16.7783 5.61351 23.2837C6.67716 26.0492 8.777 28.0598 12.0091 29.3979C16.9122 24.1552 22.2441 19.8869 28.228 16.4111C27.4011 12.9766 23.8328 4.5875 8.53682 4.80709Z",
    fill: "#1E1E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7549 17.6774C69.7549 17.6774 70.6779 1.40014 93.5566 2.45006C93.5566 2.45006 107.158 25.9704 87.9295 32.2047C82.1824 25.8057 76.0887 21.1565 69.7549 17.6774Z",
    fill: "#E2A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1847 34.9701L86.1417 33.8069C80.9092 27.9775 75.1689 23.39 68.5983 19.7805L67.2705 19.0531L67.3563 17.54C67.3666 17.3444 67.672 12.6644 71.1854 8.18675C76.9257 0.871599 86.5774 -0.274396 93.6661 0.0481298L94.9768 0.10989L95.6356 1.24559C95.9547 1.79457 103.39 14.85 99.4956 24.9924C97.756 29.5283 94.1122 32.7227 88.6704 34.4863L87.1847 34.9666V34.9701ZM72.4035 16.4146C78.3873 19.8903 83.7159 24.1552 88.6155 29.3945C91.8511 28.0564 93.9509 26.0423 95.0146 23.27C97.3134 17.2792 94.1156 8.78033 92.1015 4.80366C84.1413 4.68014 78.3736 6.81087 74.9699 11.1512C73.4294 13.1138 72.726 15.1245 72.4069 16.4146H72.4035Z",
    fill: "#1E1E22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_6887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.621,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory5);
export default __webpack_public_path__ + "static/media/accessory-5.a530df3b562919989170579131358e20.svg";
export { ForwardRef as ReactComponent };